import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import FormEditor from './formEditor';
import routeHelper from '../common/classes/routeHelper';
import { formTypePermissionSelector } from '../common/classes/permissions';
const FormEditorContainer = _ref => {
  let canView = _ref.canView,
    location = _ref.location,
    _ref$form = _ref.form,
    _ref$form2 = _ref$form === void 0 ? {
      active: {
        isNew: false
      }
    } : _ref$form,
    active = _ref$form2.active,
    _ref$form2$active = _ref$form2.active,
    _ref$form2$active2 = _ref$form2$active === void 0 ? {} : _ref$form2$active,
    _ref$form2$active2$co = _ref$form2$active2.content,
    _ref$form2$active2$co2 = _ref$form2$active2$co === void 0 ? {} : _ref$form2$active2$co,
    title = _ref$form2$active2$co2.title,
    _ref$match$params = _ref.match.params,
    cabinetIdentifier = _ref$match$params.cabinetIdentifier,
    formTypeIdentifier = _ref$match$params.formTypeIdentifier,
    id = _ref$match$params.id;
  // Redirect and post authorization error message if permissions insufficient
  useEffect(() => {
    routeHelper.handleViewRedirect(canView, location);
  }, [canView, location]);

  // define an instance variable so that useCallback methods have the latest data
  const activeRef = useRef();
  useEffect(() => {
    activeRef.current = active;
  }, [active]);
  const validate = useCallback(() => {
    const errors = [];
    const _activeRef$current = activeRef.current,
      _activeRef$current2 = _activeRef$current === void 0 ? {} : _activeRef$current,
      _activeRef$current2$c = _activeRef$current2.content,
      content = _activeRef$current2$c === void 0 ? {} : _activeRef$current2$c;

    // special casing for handling hull title validation. Can be removed when behaviors validation
    // is added: https://www.pivotaltracker.com/story/show/182516842
    if (!cabinetIdentifier && formTypeIdentifier && content.title === undefined) {
      errors.push('You must provide a title before saving. (See General Section)');
    }
    return errors;
  }, [cabinetIdentifier, formTypeIdentifier]);
  const handleBack = () => {
    if (cabinetIdentifier) {
      return routeHelper.updateURL("/cabinets/".concat(cabinetIdentifier));
    }
    return routeHelper.updateURL("/forms/".concat(formTypeIdentifier));
  };

  // jobs use "related" to pass in job operations to call. These remaining form items could probably
  // be cleaned up and put in formEditor directly
  const related = {
    onBack: handleBack,
    onValidate: validate
  };
  return /*#__PURE__*/React.createElement(FormEditor, {
    id: id,
    formTitle: title,
    related: related,
    sectionsLabel: "Sections"
  });
};
FormEditorContainer.propTypes = {
  canView: PropTypes.bool.isRequired,
  form: PropTypes.shape({
    active: PropTypes.shape({
      isNew: PropTypes.bool,
      id: PropTypes.string,
      assets: PropTypes.arrayOf(PropTypes.shape({})),
      jobNumber: PropTypes.string,
      documents: PropTypes.arrayOf(PropTypes.shape({})),
      phaseCodes: PropTypes.arrayOf(PropTypes.shape({})),
      piecesOther: PropTypes.arrayOf(PropTypes.shape({})),
      flangeValveInspection: PropTypes.arrayOf(PropTypes.shape({})),
      flangeValve: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    loading: PropTypes.bool.isRequired,
    pendingChanges: PropTypes.bool.isRequired
  }),
  formActions: PropTypes.shape({
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func,
    change: PropTypes.func
  }),
  location: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      cabinetIdentifier: PropTypes.string,
      formTypeIdentifier: PropTypes.string,
      id: PropTypes.string
    }),
    url: PropTypes.string
  }).isRequired
};
export { FormEditorContainer as TestFormEditorContainer };
export default entityComposition(FormEditorContainer, ['form'], {
  canView: formTypePermissionSelector('view_detail')
}, []);